import SwaggerClient from 'swagger-client';
import swaggerEndpoints from './swaggerEndpoints'
let swaggerClients = {};

const quickCheckFeatureFlag = function(id) {
  // does not use serviceClient to avoid circular dependency
  // draw back is feature flags have to be in session storage
  // and will not call the api to get them if they are not

  try {

    let storedFeatureFlags = sessionStorage.getItem('featureFlags');
    let flags;
    let flagActive = false;
    if (storedFeatureFlags) {
        flags = JSON.parse(storedFeatureFlags)
    } 
    if (flags) {
        const matchingFlag = flags.find(f => f.id === id);
        if (matchingFlag) {
            flagActive = matchingFlag.active;
        }
    }
    return flagActive;
  } catch(err) {
    console.error(err);
    console.error('Unable to get feature flags');
    return false;
  }

}

function isGuardedUrl(url) {
  const allowedUrls = ['/api/auth/dbauth', '/api/auth/jwt/isauthenticated', '/api/auth/setcookies', '/api/auth/sso'];

  for (const allowedUrl of allowedUrls) {
    if (url.includes(allowedUrl)) return false;
  }

  return true;
}

export default class ServiceClient {
  static async getClient(service, authorizations) {
    // if we need client for non-standard authorization, always get a new client
    if (!authorizations && swaggerClients[service]) {
      //console.log("using cached swagger client for " + service);
      return swaggerClients[service];
    } else {
      //console.log("getting new swagger client for " + service);
    }

    const client = await makeSwaggerClient({
      url: swaggerEndpoints[service],
      authorizations: authorizations? authorizations: {},

      requestInterceptor: (req) => {
        if (parent.portalEventBus){
          parent.portalEventBus.$emit('integrify-portal:serviceClient', 'request');
        }

        if (req.body instanceof FormData) {
          // Delete Content-Type to let browser set it automatically, otherwise multipart/form-data requests will fail because SwaggerClient sets Content-Type to application/json
          delete req.headers['Content-Type'];
        }
      },
      responseInterceptor: async function(res) {
        if (parent.portalEventBus)
        parent.portalEventBus.$emit('integrify-portal:serviceClient', 'response');

        if (res?.status == 401 && isGuardedUrl(res.url)) {
          window.portalGlobalEventBus.$emit('integrify-portal:sessionTimeout', { source: 'commonLib -> serviceClient -> responseInterceptor' });
        }
        
        if (res?.status >= 200 && res?.status < 400) {
          const auth = require('../auth').default
          auth.inactivityLogout.updateLastActivity();
        }

        return res
        
      },
    })
    swaggerClients[service] = client;
    return client
  }

  static async getIntegrationsClient(authorizations) {
    return await this.getClient('integrations', authorizations);
  }
}
 
async function makeSwaggerClient({ url, ...options }) {
  // https://github.com/swagger-api/swagger-js/issues/3170#issuecomment-1747192897
  // swagger-client v3.23.2 has a bug where it doesn't handle relative urls correctly
  // so we have to convert the url to an absolute url
  // as a workaround as suggested in the issue above
  url = String(new URL(url, document.baseURI));

  return await new SwaggerClient({
    url,
    ...options
  });
}
